import { Editable, EditableImage, ImageBlockZone } from "@/components/Editable";

const CONTENT = {
  about: {
    title: "About The Archives",
    body: [
      "The Archives is an unofficial fan-created community encyclopedia. It is not affiliated with, operated by, or officially endorsed by Ghoulax, Zyfley, Ghoulax Studio's, or any associated organization unless explicitly stated otherwise.",
      "Some pages contain satire, jokes, exaggeration, and community-created lore. Such material should not be interpreted as factual unless explicitly identified as verified information.",
      "The project exists to document the people, projects, events, quotes, and lore surrounding these communities — with an unnecessarily serious tone and, allegedly, no bias whatsoever.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    body: [
      "The Archives is an unofficial fan-made community encyclopedia. It is not affiliated with or endorsed by any individual or organization documented within it.",
      "Content marked VERIFIED reflects information provided or confirmed by the site owner. Content marked COMMUNITY LORE, SATIRE, or UNCONFIRMED is not factual and should not be treated as such.",
      "Where information is not known, the site states 'Not publicly documented' rather than inventing details. Quotes, dates, and sources are never fabricated.",
    ],
  },
  privacy: {
    title: "Privacy",
    body: [
      "The Archives does not collect unnecessary personal information.",
      "We do not publicly display IP addresses, private emails, private Discord information, real-world addresses, school information, phone numbers, or private social accounts.",
      "Pages about private individuals are not created unless there is a legitimate public or community reason and the information is appropriate to include.",
    ],
  },
  contact: {
    title: "Contact",
    body: [
      "The Archives is maintained by community administrators.",
      "To suggest a correction or addition, use the 'Suggest an Edit' button available on any article. Submissions are reviewed by an administrator before publication.",
      "For matters requiring an administrator, please reach out through the community's official channels.",
    ],
  },
};

export default function StaticPage({ page }) {
  const c = CONTENT[page] || CONTENT.about;
  const bodyHtml = c.body.map((p) => `<p>${p}</p>`).join("");
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
      <Editable id={`static.${page}.title`} as="h1" fallback={c.title} className="font-serif-arc text-3xl font-black tracking-tight sm:text-4xl" />
      <Editable id={`static.${page}.body`} as="div" mode="rich" fallback={bodyHtml} className="article-body mt-6" />
      <EditableImage id={`static.${page}.image`} className="mt-8 w-full rounded-md object-cover" label="image" />
      <ImageBlockZone id={`static.${page}.blocks`} className="mt-8" />
      <Editable id={`static.${page}.footer`} as="p" fallback="The Archives has absolutely no bias whatsoever." className="mt-10 text-xs italic" style={{ color: "var(--arc-text-2)" }} />
    </div>
  );
}
